export default "__VITE_ASSET__665e10ae__"